import React from 'react';
import { Container, Row, Col, CardGroup, Card, Button } from 'react-bootstrap';
import localSeller from './../../assets/localSeller.png';
import pharmacy from './../../assets/pharmacy.png';
import store from './../../assets/store.png';
import techStore from './../../assets/techStore.png';
import vendor from './../../assets/vendor.png';
import serviceProvider from './../../assets/serviceProvider.png';
import { Link } from 'react-router-dom'

export default function ServiceRegister() {
    return (
        <div className='py-4'>
            <Container style={{ background: '#d0d8ff' }} className='text-white p-5 rounded-3'>
                <h1 className='text-center'>Be a Seller</h1>
            </Container>
            <Container>
                <Row className='py-4'>
                    <CardGroup>
                        <Col md={4} className='ps-1 pe-3 pb-5'>
                            <Card className='border-0 shadow sellerCards'>
                                <div className='d-flex justify-content-center py-4'>
                                    <img alt='localSeller' variant="top" src={localSeller} height={'100px'} width='100px' />
                                </div>
                                <Card.Body className='mt-1'>
                                    <Card.Title>Become a Local Seller</Card.Title>
                                    <Card.Text>
                                        Register yourself as a local seller & start selling products.
                                    </Card.Text>
                                    <div className='text-center'>
                                        <Link to={'/register-store'} state={{ id: 1 }}>
                                            <Button>Register Now</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className='ps-1 pe-3 pb-5'>
                            <Card className='border-0 shadow sellerCards'>
                                <div className='d-flex justify-content-center py-4'>
                                    <img alt='localSeller' variant="top" src={store} height={'100px'} width='100px' />
                                </div>
                                <Card.Body className='mt-1'>
                                    <Card.Title>Register your Store</Card.Title>
                                    <Card.Text>
                                        Register your store & start generating revenues.
                                    </Card.Text>

                                    <div className='text-center'>
                                        <Link to={'/register-store'} state={{ id: 2 }}>
                                            <Button>Register Now</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className='ps-1 pe-3 pb-5'>
                            <Card className='border-0 shadow sellerCards'>
                                <div className='d-flex justify-content-center py-4'>
                                    <img alt='localSeller' variant="top" src={pharmacy} height={'100px'} width='100px' />
                                </div>
                                <Card.Body className='mt-1'>
                                    <Card.Title>Register Your Pharmacy</Card.Title>
                                    <Card.Text>
                                        Register your pharmacy, clinic or any medical service here.
                                    </Card.Text>
                                    <div className='text-center'>
                                        <Link to={'/register-store'} state={{ id: 4 }}>
                                            <Button>Register Now</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className='ps-1 pe-3'>
                            <Card className='border-0 shadow sellerCards'>
                                <div className='d-flex justify-content-center py-4'>
                                    <img alt='localSeller' variant="top" src={techStore} height={'100px'} width='100px' />
                                </div>
                                <Card.Body className='mt-1'>
                                    <Card.Title>Register Your Tech Store</Card.Title>
                                    <Card.Text>
                                        Register your tech store & start selling tech products.
                                    </Card.Text>
                                    <div className='text-center'>
                                        <Link to={'/register-store'} state={{ id: 3 }}>
                                            <Button>Register Now</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className='ps-1 pe-3'>
                            <Card className='border-0 shadow sellerCards'>
                                <div className='d-flex justify-content-center py-4'>
                                    <img alt='localSeller' variant="top" src={serviceProvider} height={'100px'} width='100px' />
                                </div>
                                <Card.Body className='mt-1'>
                                    <Card.Title>Become Service Provider</Card.Title>
                                    <Card.Text>
                                        Register your service and start selling here.
                                    </Card.Text>
                                    <div className='text-center'>
                                        <Link to={'/service-provider-register'} state={{ id: 5 }}>
                                            <Button>Register Now</Button>
                                        </Link>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>

                        <Col md={4} className='ps-1 pe-3'>
                            <Card className='border-0 shadow sellerCards'>
                                <div className='d-flex justify-content-center py-4'>
                                    <img alt='localSeller' variant="top" src={vendor} height={'100px'} width='100px' />
                                </div>
                                <Card.Body className='mt-1'>
                                    <Card.Title>Register Vendor</Card.Title>
                                    <Card.Text>
                                        Register yourself as a vendor & have more clients.
                                    </Card.Text>
                                    <div className='text-center'>
                                        <Button>Register Now</Button>
                                    </div>
                                </Card.Body>
                            </Card>
                        </Col>
                    </CardGroup>
                </Row>
            </Container>
        </div>
    )
}